import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ slug, children }) {
  const key = `s24_cart_${slug}`;
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(key, JSON.stringify(items)); }, [items, key]);

  // extra: { price, variant_id, sku, image } for products with variants (priced per variant)
  const add = (product, variant, qty = 1, extra = {}) => {
    const lineId = product.id + (extra.variant_id ? `::${extra.variant_id}` : variant ? `::${variant}` : "");
    setItems((prev) => {
      const found = prev.find((i) => i.lineId === lineId);
      if (found) return prev.map((i) => i.lineId === lineId ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, {
        lineId, product_id: product.id, name: product.name, price: extra.price ?? product.price,
        variant_id: extra.variant_id || null, sku: extra.sku || null,
        image: extra.image || product.image, variant: variant || null, quantity: qty,
        tax_rate: product.tax_rate || 0, tax_type: product.tax_type || "", tax_inclusive: !!product.tax_inclusive,
      }];
    });
    setOpen(true);
  };
  const updateQty = (lineId, qty) => {
    if (qty <= 0) return remove(lineId);
    setItems((prev) => prev.map((i) => i.lineId === lineId ? { ...i, quantity: qty } : i));
  };
  const remove = (lineId) => setItems((prev) => prev.filter((i) => i.lineId !== lineId));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, updateQty, remove, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
